// extracted by mini-css-extract-plugin
module.exports = {"tableSection":"tables_tableSection__3xGCS","dataTable":"tables_dataTable__3tuYQ","header":"tables_header__1t7f2","numericalData":"tables_numericalData__2CEL3"};